"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = exports.PriceCellView = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var formatting_1 = require("lets-trade-utils/lib/utils/formatting");
var react_redux_1 = require("react-redux");
var status_cell_view_1 = require("../../../../../../components/table/tableCell/status_cell_view");
var deliveryFormat = function (o) {
    {
        var value = "No";
        if (o) {
            if (o.delivery) {
                if (o.delivery.delivery === false) {
                    value = "No";
                }
                else {
                    value = "Yes";
                }
            }
            return value;
        }
        return "";
    }
};
function PriceCellView(_a) {
    var _b;
    var cellValue = _a.cellValue, client = _a.client;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small capitalize text-default-foreground" }, { children: (0, formatting_1.formatMoney)({
            symbol: client === null || client === void 0 ? void 0 : client.currency_symbol,
            value: (_b = cellValue === null || cellValue === void 0 ? void 0 : cellValue.toString()) !== null && _b !== void 0 ? _b : "0",
            symbolSeparation: true,
        }) })));
}
exports.PriceCellView = PriceCellView;
function useRenderCellViews() {
    var client = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).client;
    var renderCellViews = (0, react_1.useCallback)(function (cellValue) {
        return [
            {
                key: "total_revenue",
                content: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "" }, { children: ["R", cellValue] })),
            },
            {
                key: "average_revenue",
                content: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "" }, { children: ["R", cellValue] })),
            },
            {
                key: "delivery",
                content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "" }, { children: deliveryFormat(cellValue) })),
            },
            { key: "status", content: (0, jsx_runtime_1.jsx)(status_cell_view_1.StatusCellView, { cellValue: cellValue }) },
        ];
    }, [client]);
    return (0, react_1.useMemo)(function () { return ({ renderCellViews: renderCellViews }); }, [renderCellViews]);
}
exports.useRenderCellViews = useRenderCellViews;
